/**
 * Accessible tabs for Volier sections: [data-tab] buttons switch [data-panel] panels (same order).
 * Arrow keys move between tabs; the theme editor's block:select opens the selected tab.
 */
class VolierTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-tab]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (event) => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        const next = (i + step + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      });
    });

    this.onBlockSelect = (event) => {
      const index = this.tabs.indexOf(event.target);
      if (index !== -1) this.select(index);
    };
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
      if (i === index) panel.querySelector('.vf__track')?.scrollTo({ left: 0 });
    });
  }
}

if (!customElements.get('volier-tabs')) customElements.define('volier-tabs', VolierTabs);
